import type {TuiCountryIsoCode, TuiLanguage, TuiLanguageCommerce, TuiLanguageCore, TuiLanguageEditor, TuiLanguageKit, TuiLanguageLayout, TuiLanguageTable} from '@taiga-ui/i18n/types';

export const TUI_HUNGARIAN_LANGUAGE_ADDON_COMMERCE: TuiLanguageCommerce = {
    cardNumber: ['Szám', 'Kártyaszám'],
    cardExpiry: ['Lejárat', 'Lejárati dátum'],
};

export const TUI_HUNGARIAN_LANGUAGE_LAYOUT: TuiLanguageLayout = {
    inputSearch: {
        popular: 'Népszerű',
        history: 'Legutóbbi',
        placeholder: 'Keresés',
        hotkey: 'a kereséshez',
        all: 'Összes',
        empty: 'Nincs találat',
    },
};

export const TUI_HUNGARIAN_LANGUAGE_KIT: TuiLanguageKit = {
    cancel: 'Mégse',
    done: 'Kész',
    more: 'Több',
    otherDate: 'Más dátum...',
    showAll: 'Összes mutatása',
    hide: 'Elrejtés',
    mobileCalendarTexts: [
        'Válasszon napot',
        'Válasszon időszakot',
        'Válasszon napokat',
    ],
    range: ['Tól', 'Ig'],
    countTexts: ['Több', 'Kevesebb'],
    time: {
        'HH:MM': 'HH:MM',
        'HH:MM AA': 'HH:MM AA',
        'HH:MM:SS': 'HH:MM:SS',
        'HH:MM:SS AA': 'HH:MM:SS AA',
        'HH:MM:SS.MSS': 'HH:MM:SS.MSS',
        'HH:MM:SS.MSS AA': 'HH:MM:SS.MSS AA',
    },
    dateTexts: {
        DMY: 'nap.hónap.év',
        MDY: 'hónap.nap.év',
        YMD: 'év.hónap.nap',
    },
    digitalInformationUnits: ['Bájt', 'Kilobyte', 'Megabyte'],
    passwordTexts: ['Jelszó mutatása', 'Jelszó elrejtése'],
    copyTexts: ['Másolás', 'Másolva'],
    shortCalendarMonths: [
        'Jan',
        'Feb',
        'Már',
        'Ápr',
        'Máj',
        'Jún',
        'Júl',
        'Aug',
        'Szep',
        'Okt',
        'Nov',
        'Dec',
    ],
    pagination: ['Előző oldal', 'Következő oldal'],
    fileTexts: {
        loadingError: 'Betöltési hiba',
        preview: 'Előnézet',
        remove: 'Eltávolítás',
    },
    inputFileTexts: {
        defaultLabelSingle: 'vagy húzza ide',
        defaultLabelMultiple: 'vagy húzza ide őket',
        defaultLinkSingle: 'Fájl kiválasztása',
        defaultLinkMultiple: 'Fájlok kiválasztása',
        maxSizeRejectionReason: 'A fájl túl nagy',
        formatRejectionReason: 'Érvénytelen fájlformátum',
        drop: 'Húzza ide a fájlt',
        dropMultiple: 'Húzza ide a fájlokat',
    },
    multiSelectTexts: {
        all: 'Összes kijelölése',
        none: 'Semmi kijelölése',
    },
    confirm: {
        yes: 'Igen',
        no: 'Nem',
    },
    previewTexts: {
        rotate: 'Forgatás',
    },
    zoomTexts: {
        zoomOut: 'Kicsinyítés',
        zoomIn: 'Nagyítás',
        reset: 'Visszaállítás',
    },
    phoneSearch: 'Ország vagy kód keresése',
};

export const TUI_HUNGARIAN_LANGUAGE_ADDON_EDITOR: TuiLanguageEditor = {
    colorSelectorModeNames: ['Egyszínű', 'Színátmenet'],
    toolbarTools: {
        undo: 'Visszavonás',
        redo: 'Újra',
        font: 'Betűtípus',
        fontStyle: 'Betűstílus',
        fontSize: 'Betűméret',
        bold: 'Félkövér',
        italic: 'Dőlt',
        underline: 'Aláhúzás',
        strikeThrough: 'Áthúzás',
        justify: 'Igazítás',
        justifyLeft: 'Balra igazítás',
        justifyCenter: 'Középre igazítás',
        justifyRight: 'Jobbra igazítás',
        justifyFull: 'Sorkizárt',
        list: 'Lista',
        indent: 'Behúzás növelése',
        outdent: 'Behúzás csökkentése',
        unorderedList: 'Felsorolás',
        orderedList: 'Számozás',
        quote: 'Idézet',
        foreColor: 'Szövegszín',
        backColor: 'Háttérszín',
        hiliteColor: 'Kiemelő szín',
        clear: 'Törlés',
        link: 'Hivatkozás',
        attach: 'Fájl csatolása',
        tex: 'TeX beszúrása',
        code: 'Kód',
        image: 'Kép beszúrása',
        insertHorizontalRule: 'Vízszintes vonal beszúrása',
        superscript: 'Felső index',
        subscript: 'Alsó index',
        insertTable: 'Táblázat beszúrása',
        insertGroup: 'Csoport beszúrása',
        hiliteGroup: 'Csoport kiemelése',
        removeGroup: 'Csoport eltávolítása',
        insertAnchor: 'Horgony beszúrása',
        mergeCells: 'Cellák egyesítése',
        splitCells: 'Cellák felosztása',
        rowsColumnsManaging: 'Sorok és oszlopok kezelése',
        cellColor: 'Cella színe',
        setDetails: 'Részletek beállítása',
        removeDetails: "Részletek eltávolítása",
    },
    editorEditLink: {
        urlExample: 'pelda.com',
        anchorExample: 'horgony',
    },
    editorTableCommands: [
        ['Oszlop beszúrása előtte', 'Oszlop beszúrása utána'],
        ['Sor beszúrása előtte', 'Sor beszúrása utána'],
        ['Oszlop törlése', 'Sor törlése'],
    ],
    editorCodeOptions: ['Kód szövegben', 'Kódblokk'],
    editorFontOptions: {
        small: 'Kicsi',
        large: 'Nagy',
        normal: 'Normál',
        title: 'Cím',
        subtitle: 'Alcím',
    },
};

export const TUI_HUNGARIAN_LANGUAGE_ADDON_TABLE: TuiLanguageTable = {
    showHideText: 'Mutat/Elrejt',
    paginationTexts: {
        pages: 'Oldalak',
        linesPerPage: 'Sor oldalanként',
        of: 'az',
    },
};

export const TUI_HUNGARIAN_LANGUAGE_CORE: TuiLanguageCore = {
    months: [
        'Január',
        'Február',
        'Március',
        'Április',
        'Május',
        'Június',
        'Július',
        'Augusztus',
        'Szeptember',
        'Október',
        'November',
        'December',
    ],
    close: 'Bezárás',
    clear: 'Törlés',
    nothingFoundMessage: 'Nincs találat',
    defaultErrorMessage: 'Érvénytelen érték',
    spinTexts: ['Előző', 'Következő'],
    shortWeekDays: ['Hét', 'Kedd', 'Szer', 'Csüt', 'Pént', 'Szom', 'Vas'],
    countries: {} as Record<TuiCountryIsoCode, string>,
};

export const TUI_HUNGARIAN_LANGUAGE: TuiLanguage = {
    name: 'hungarian',
    ...TUI_HUNGARIAN_LANGUAGE_CORE,
    ...TUI_HUNGARIAN_LANGUAGE_KIT,
    ...TUI_HUNGARIAN_LANGUAGE_ADDON_TABLE,
    ...TUI_HUNGARIAN_LANGUAGE_ADDON_COMMERCE,
    ...TUI_HUNGARIAN_LANGUAGE_ADDON_EDITOR,
    ...TUI_HUNGARIAN_LANGUAGE_LAYOUT,
};